import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChangeLogs } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetTransactionStatementsChangeLogsQuery } from '../store/services/customers';

const InternalTransactionChangeLog = (): React.JSX.Element => {
  const {
    customersProblemTransactions: {
      internal: { changeLogs, changeLogsPagination },
    },
    customersDictionaries: { activePermissions },
    administrationDictionaries: { users },
  } = useAppSelector((state) => state);

  const { transactionId } = useParams();

  const [getChangeLogs, { isLoading, isFetching }] =
    useLazyGetTransactionStatementsChangeLogsQuery();

  const getChangeLogsAction = useCallback(
    (cursor?: string) => {
      getChangeLogs(
        `?take=20&entityType=TRANSACTION&entityId=${transactionId}${
          cursor ? `&cursor=${cursor}` : ''
        }`,
      );
    },
    [transactionId],
  );

  useEffect(() => {
    getChangeLogsAction();
  }, []);

  return (
    <ChangeLogs
      entityType="TRANSACTION"
      entityId={transactionId as string}
      changeLogsIsLoading={isLoading}
      changeLogs={changeLogs}
      activePermission={activePermissions}
      users={users}
      pagination={changeLogsPagination}
      changeLogsIsFetching={isFetching}
      getChangeLogs={getChangeLogsAction}
    />
  );
};

export default InternalTransactionChangeLog;
